export default __webpack_public_path__ + "static/reverseLogo-a270f34de815e4fb22f65bd519ae55b5.png";